/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const impactCountsSchema = z.object({
  estimateChanges: z.int(),
  priorityChanges: z.int(),
  scheduleShifts: z.int(),
  teamChanges: z.int(),
});
